export default __webpack_public_path__ + "static/Inter-Bold-d51f80ac117a869449dbc1bd4040008e.woff2";